import { render, staticRenderFns } from "./towerhillHomes.vue?vue&type=template&id=4de05a32&"
import script from "./towerhillHomes.vue?vue&type=script&lang=js&"
export * from "./towerhillHomes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports